// extracted by mini-css-extract-plugin
module.exports = {"moduleFaqs":"ModuleFaqs_moduleFaqs__DgKAG","moduleFaqsContainer":"ModuleFaqs_moduleFaqsContainer__VEt5g","faqs":"ModuleFaqs_faqs__4DXHN"};